import { IGraffitiOption } from '../../interface/Graffiti'

export const defaultGraffitiOption: Readonly<Required<IGraffitiOption>> = {
  defaultLineColor: '#000000',
  defaultLineWidth: 2
}